/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState, useCallback } from "react";
import { io } from "socket.io-client";
import { QRCodeCanvas } from "qrcode.react";
import { toPng } from "html-to-image";
import { formatCurrency } from "../../utils/SamuiUtils";

const BANNER =
  "https://files.appsystemyou.com/systemyou/SO_H/974076.jpg";

const BANNER2 =
  "https://files.appsystemyou.com/systemyou/SO_H/FDownloader.Net_AQOV7yCTYTMv41A2EBt2a1k26wKh7QeqChfQJHsaS5Xt2Wg5_uyjuo4OPAxwhrGxutPwF6iRyLcYzfH66AycMgnEMEAM4UF9r_IzlyDPQHRfrA_720p_(HD).mp4";

const BACKEND_URL =
  process.env.REACT_APP_API_URL || "https://pbposuat-backend.appsystemyou.com";
const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH || "/socket.io";

/* helpers */
const getURL = () =>
  typeof window !== "undefined" ? new URL(window.location.href) : null;
const getParam = (k) => {
  const u = getURL();
  return u ? u.searchParams.get(k) : null;
};
const removeParam = (k) => {
  const u = getURL();
  if (!u) return;
  u.searchParams.delete(k);
  window.history.replaceState({}, "", u.toString());
};

/* simple hook */
function useWindowWidth() {
  const [w, setW] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );
  useEffect(() => {
    const onR = () => setW(window.innerWidth);
    window.addEventListener("resize", onR);
    return () => window.removeEventListener("resize", onR);
  }, []);
  return w;
}

export default function Page2screen() {
  const width = useWindowWidth();
  const socketRef = useRef(null);
  const cardRef = useRef(null);

  // state - Support multiple concurrent sessions
  const [connected, setConnected] = useState(false);
  const [sessions, setSessions] = useState([]); // Array of active payment sessions
  const [completedSessions, setCompletedSessions] = useState([]); // Recently completed sessions

  // Original state needed for single session payment UI
  const [orderStatus, setOrderStatus] = useState(0); // 0=idle, 1=paid, 2=qr
  const [order, setOrder] = useState(null);
  const [items, setItems] = useState([]);
  const [promptpayQR, setPromptpayQR] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [chargeId, setChargeId] = useState(null);
  const [amount, setAmount] = useState(null);
  const [countdown, setCountdown] = useState(300);
  const hasPaidRef = useRef(false);

  const formatPrice = (v) => {
    const n = Number(v);
    if (isNaN(n)) return "฿ 0";
    return `฿ ${n.toLocaleString()}`;
  };

  const fetchStatus = useCallback(
    async (sid) => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/payments/${sid}/status`);
        if (!res.ok) return;
        const data = await res.json();
        setOrder({
          Order_no: data.sessionId ?? sid,
          Payment_Date: data.updatedAt ?? new Date().toISOString(),
          Cust_name: data.customerName ?? "",
          Cust_tel: data.customerTel ?? "",
          Pay_By_Name: data.payByName ?? "QR",
          Total_Price: data.amount ?? amount ?? 0,
          Total_Pay: data.balance ?? 0,
          TicketNo_List: (data.seats || []).join(", "),
          img: "",
        });
        // ถ้าฝั่ง backend มี items ก็อาจ map เข้ามาแทนนี้
      } catch (e) {
        console.error("fetchStatus error:", e);
      }
    },
    [amount]
  );

  const handleDownloadOrPrompt = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isIOS && isSafari) return; // ไม่เด้งดาวน์โหลดบน iOS Safari
    if (!cardRef.current) return;
    toPng(cardRef.current).then((dataUrl) => {
      const link = document.createElement("a");
      link.download = "payment-confirmation.png";
      link.href = dataUrl;
      link.click();
    });
  };
  const currentSessionRef = useRef(null);
  /* Socket.IO */
  useEffect(() => {
    const sock = io(BACKEND_URL, {
      path: SOCKET_PATH, // ต้องตรงกับ server
      // transports: ["websocket"],  // ถ้า proxy/Ingress มีปัญหา ให้คอมเมนต์ไว้ใช้ค่า default
    });

    socketRef.current = sock;

    // --- lifecycle ---
    sock.on("connect", () => {
      setConnected(true);
      console.debug("connected:", sock.id);
      // จอสองทุกเครื่องเข้าห้องกลางไว้ก่อน
      sock.emit("join-room", "DISPLAY");
    });

    sock.on("disconnect", (reason) => {
      setConnected(false);
      console.debug("disconnect:", reason);
    });

    sock.on("connect_error", (err) => {
      console.debug("connect_error:", err?.message, err);
    });

    // --- events จากแคชเชียร์/เซิร์ฟเวอร์ ---
    // แสดง QR + เข้าห้องเฉพาะบิล
    sock.on("qr:show", (p = {}) => {
      if (!p.sessionId) return;

      const sid = String(p.sessionId);
      currentSessionRef.current = sid;

      // เข้าห้อง session เพื่อรออีเวนต์ต่อไปของบิลนี้
      sock.emit("join-room", sid);

      setSessionId(sid);
      setOrderId(sid);
      setChargeId(p.chargeId ?? null);
      setAmount(p.amount ?? null);
      setItems(Array.isArray(p.items) ? p.items : []);
      setPromptpayQR(p.qrData ?? null);
      setOrderStatus(2);
      setCountdown(300); // Reset countdown
    });

    // ปิดบิล/ปิด QR
    sock.on("qr:close", (p = {}) => {
      if (!p.sessionId || p.sessionId !== currentSessionRef.current) return;
      resetScreen();
    });

    // ชำระสำเร็จเฉพาะบิลนี้
    sock.on("payment:success", (p = {}) => {
      if (!p.sessionId || p.sessionId !== currentSessionRef.current) return;
      hasPaidRef.current = true;
      setOrderStatus(1);
      // ถ้าต้องการดึงสถานะจาก API:
      // fetchStatus(p.sessionId);
      setTimeout(() => resetScreen(), 3500);
    });

    // ยกเลิกเฉพาะบิลนี้
    sock.on("payment:cancelled", (p = {}) => {
      if (!p.sessionId || p.sessionId !== currentSessionRef.current) return;
      resetScreen();
    });

    // cleanup
    return () => {
      try {
        sock.removeAllListeners();
        sock.disconnect();
      } catch {}
    };
  }, []); // อย่าใส่ deps อื่นเพื่อไม่ให้สมัคร event ซ้ำ

  // มี orderId ใหม่ -> ลองดึงสถานะ (เผื่อรีเฟรชหน้า)
  useEffect(() => {
    if (orderId != null) {
      hasPaidRef.current = false;
      setOrder(null);
      fetchStatus(orderId);
    }
  }, [orderId]);

  const resetScreen = () => {
    hasPaidRef.current = false;
    setOrderStatus(0);
    setOrder(null);
    setItems([]);
    setPromptpayQR(null);
    setOrderId(null);
    setSessionId(null);
    setChargeId(null);
    setAmount(null);
    setCountdown(300);
    removeParam("sessionId");
  };

  // Polling for payment status
  useEffect(() => {
    if (orderStatus !== 2 || !chargeId) return;

    const interval = setInterval(async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/payment/qr-tx/${chargeId}`);
        if (res.ok) {
          const data = await res.json();
          if (data.status === "success") {
            // Payment successful, wait for socket event or handle it here
            // But usually socket event "payment:success" will handle it.
            // If socket is delayed, we might want to trigger something, 
            // but let's rely on socket for now to avoid double handling.
            console.log("Polling: Payment success");
          }
        }
      } catch (e) {
        console.error("Polling error:", e);
      }
    }, 2000); // Poll every 2 seconds

    return () => clearInterval(interval);
  }, [orderStatus, chargeId]);

  // Countdown timer
  useEffect(() => {
    if (orderStatus !== 2 || countdown <= 0) return;

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [orderStatus, countdown]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  const itemsTotal = items.reduce((s, it) => s + Number(it.amount || 0), 0);

  return (
    <>
      <div className={`twoscreen${orderStatus === 0 ? ' idle-mode' : ''}`}>
        {/* LEFT */}
        {orderStatus === 0 && (
          <aside className="left-panel">
            <video
              src={BANNER2}
              autoPlay
              loop
              muted
              playsInline
              className="banner-video"
            />
          </aside>
        )}

        <section className="right-panel" style={{ display: orderStatus === 0 ? 'none' : 'flex' }}>
          {orderStatus === 2 && (
            <div className="card qr-card-layout">
              <div className="title qr-card-title">
                โปรดสแกนเพื่อชำระเงิน
              </div>

              <div className="qr-wrap">
                <div className="qr-side-banner">
                  <video
                    src={BANNER2}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="banner-video"
                  />
                </div>
                
                <div className="qr-side-content">
                  <div className="qr-box">
                    {promptpayQR ? (
                      promptpayQR.startsWith("data:image/") ||
                      promptpayQR.startsWith("http") ||
                      promptpayQR.startsWith("/") ? (
                        <img
                          src={promptpayQR}
                          alt="QR Code"
                          className="qr-image"
                        />
                      ) : (
                        <QRCodeCanvas
                          value={String(promptpayQR ?? "")}
                          size={280}
                          className="qr-canvas"
                          includeMargin
                        />
                      )
                    ) : (
                      <div className="subtitle">กำลังเตรียม QR…</div>
                    )}
                  </div>
                  {amount != null && (
                    <div className="price-tag-responsive">
                      <div className="price-display">
                        <span className="price-label">ราคา</span>
                        <span className="price-value">{formatCurrency(amount)} บาท</span>
                      </div>
                      <div className="countdown-display">
                        Time remaining: {formatTime(countdown)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {orderStatus === 1 && (
            <div
              ref={cardRef}
              className="card paid-card"
            >
              <img
                src="paid.png"
                alt="paid"
                className="paid-image"
              />
            </div>
          )}
        </section>
      </div>

      {/* ===== styled-jsx global ===== */}
      <style jsx global>{`
        :root {
          --bg: #0b0d12;
          --bg-2: #121622;
          --card: #171c29;
          --card-2: #1e2433;
          --muted: #9aa3b2;
          --text: #e6ebf5;
          --accent: #ff4d4d;
          --ok: #22c55e;
          --bad: #ef4444;
          --border: rgba(255, 255, 255, 0.08);
          --shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
          --radius: 22px;
        }
        * {
          box-sizing: border-box;
        }
        html,
        body,
        #root {
          height: 100%;
        }
        body {
          margin: 0;
          background: var(--bg);
          color: var(--text);
          font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI",
            Roboto, "Helvetica Neue", Arial;
        }

        .twoscreen {
          height: 100vh;
          width: 100vw;
          display: flex;
          flex-direction: row;
          align-items: stretch;
          padding: 0;
          margin: 0;
          background: var(--bg);
          overflow: hidden;
        }
        .twoscreen.idle-mode {
          justify-content: flex-start;
          align-items: stretch;
          background: #000;
        }
        .twoscreen.idle-mode .left-panel {
          flex: 1 1 0;
          width: 100vw;
          height: 100vh;
          border-radius: 0;
          box-shadow: none;
          aspect-ratio: unset;
        }

        .left-panel {
          position: relative;
          overflow: hidden;
          background: var(--card);
          flex: 1 1 0;
          min-width: 0;
          display: flex;
        }

        .banner-video {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .idle-mode .banner-video {
          object-fit: contain;
          background: #000;
        }

        .right-panel {
          display: flex;
          flex-direction: column;
          flex: 2 1 0;
          min-width: 0;
          height: 100vh;
        }

        .card {
          background: linear-gradient(
            180deg,
            var(--card) 0%,
            var(--card-2) 100%
          );
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 2vh 2vw;
          border-radius: 0;
          border: none;
        }
        
        .qr-card-title {
          color: #ff4d4d;
          font-weight: 800;
          font-size: clamp(18px, 3vw, 28px);
          margin-bottom: 1.5vh;
          text-align: center;
          width: 100%;
        }

        .qr-wrap {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: 3vw;
          width: 100%;
          flex: 1;
          min-height: 0;
        }
        
        .qr-side-banner {
          position: relative;
          flex: 1 1 0;
          min-width: 0;
          height: 100%;
          max-height: 70vh;
          overflow: hidden;
        }

        .qr-side-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex: 2 1 0;
          min-width: 0;
          gap: 2vh;
        }

        .qr-box {
          width: clamp(260px, 38vw, 480px);
          height: clamp(260px, 38vw, 480px);
          border-radius: 14px;
          background: #0e1320;
          display: grid;
          place-items: center;
          border: 1px solid var(--border);
        }

        .qr-image,
        .qr-canvas {
          width: 95%;
          height: 95%;
          object-fit: contain;
        }

        .price-tag-responsive {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          width: min(100%, 360px);
        }

        .price-display {
          color: #ee0e0eff;
          font-weight: 800;
          font-size: clamp(22px, 3.5vw, 32px);
          text-shadow: 0 1px 0 #000, 0 2px 8px rgba(0, 0, 0, 0.35);
        }

        .price-label {
          opacity: 0.85;
          margin-right: 8px;
        }

        .price-value {
          color: #ee0e0eff;
        }

        .countdown-display {
          font-size: clamp(16px, 2.5vw, 22px);
          margin-top: 8px;
          color: #fff;
          font-weight: bold;
        }

        @media (max-width: 1024px) and (max-height: 600px) {
          .card {
            padding: 1.5vh 1.5vw 1vh;
          }

          .qr-card-title {
            margin-bottom: 1vh;
            font-size: clamp(16px, 2.2vw, 22px);
          }

          .qr-wrap {
            gap: 2vw;
            align-items: center;
          }

          .qr-side-banner {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 72vh;
            max-height: 72vh;
          }

          .qr-side-content {
            justify-content: center;
            gap: 1vh;
            height: 72vh;
          }

          .qr-box {
            width: clamp(260px, 36vw, 420px);
            height: clamp(260px, 36vw, 420px);
          }

          .qr-image,
          .qr-canvas {
            width: 95%;
            height: 95%;
          }

          .price-tag-responsive {
            width: min(100%, 300px);
            gap: 4px;
          }

          .price-display {
            font-size: clamp(17px, 2.3vw, 22px);
            line-height: 1.1;
          }

          .countdown-display {
            margin-top: 0;
            font-size: clamp(13px, 1.8vw, 17px);
          }
        }

        .paid-card {
          padding: 0;
          flex: 1;
          height: 100vh;
          display: grid;
          place-items: center;
          background: #fff;
          border-radius: 0;
          border: none;
        }
        
        .paid-image {
          width: 65%;
          height: 100%;
          object-fit: contain;
        }
      `}</style>
    </>
  );
}
